// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"2440":"datadogProfiler","3581":"datadogRecorder"}[chunkId] || chunkId) + ".js";
};